import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { Form, InputNumber, Modal } from "antd";
import * as React from "react";
import { Button } from "src/components";
import { PaymentSetting } from "src/types";

export type PaymentSettingFormValues = {
  depositMin: number;
};

export type PaymentSettingFormProps = {
  item: PaymentSetting;
  onSubmit: (values: PaymentSettingFormValues) => void;
};

export const PaymentSettingForm = NiceModal.create((props: PaymentSettingFormProps) => {
  const { item, onSubmit } = props;
  const { visible, hide, remove } = useModal();
  const [isValid, setIsValid] = React.useState(false);
  const [hasChanged, setHasChanged] = React.useState(false);

  const [form] = Form.useForm<PaymentSettingFormValues>();

  const handleClose = () => {
    hide();
  };

  const handleFieldsChange = (_: any[], allFields: any[]) => {
    const nextIsValid = allFields.every(
      (field) => field.value !== undefined && field.errors.length === 0
    );
    setIsValid(nextIsValid);
  };

  const handleValuesChange = (_: any, values: PaymentSettingFormValues) => {
    const nextHasChanged = values.depositMin !== item.depositMin;
    setHasChanged(nextHasChanged);
  };

  const handleFinish = (values: PaymentSettingFormValues) => {
    onSubmit(values);
    remove();
  };

  return (
    <Modal
      focusTriggerAfterClose={false}
      visible={visible}
      afterClose={remove}
      title={"แก้ไขขั้นต่ำในการเติมเงิน"}
      closable={false}
      width={520}
      centered
      footer={
        <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 8px" }}>
          <Button key="cancel" size="large" onClick={handleClose} style={{ width: "100px" }}>
            ยกเลิก
          </Button>
          <Button
            key="submit"
            size="large"
            type="primary"
            style={{ width: "160px" }}
            onClick={() => form.submit()}
            disabled={!hasChanged || !isValid}
          >
            บันทึก
          </Button>
        </div>
      }
    >
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        requiredMark={false}
        onFinish={handleFinish}
        initialValues={{
          depositMin: item.depositMin,
        }}
        onFieldsChange={handleFieldsChange}
        onValuesChange={handleValuesChange}
      >
        <Form.Item
          name="depositMin"
          label="ขั้นต่ำในการเติมเงิน"
          rules={[
            { required: true, message: "กรุณากรอกขั้นต่ำในการเติมเงิน" },
            {
              type: "number",
              min: 0,
              message: "ขั้นต่ำในการเติมเงินต้องมากกว่าหรือเท่ากับ 0",
            },
          ]}
        >
          <InputNumber
            size="large"
            min={0}
            style={{ width: "100%" }}
            placeholder="0"
            precision={0}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
});
